export default "<div class=\"ngx-group\"\n     [ngClass]=\"groupClasses\">\n    <ng-content></ng-content>\n</div>"